var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSeatMassage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95775 8.03448C6.23173 6.7931 8.0126 4.31034 12.9443 4.31034C13.2182 3.2069 14.2594 1 16.232 1H35.5477C36.3184 1.12934 37.812 1.74385 37.995 3.18475C38.3755 3.11257 38.7936 3.06897 39.2464 3.06897C41.7122 3.06897 45 3.89655 45 8.86207V17.9655V20.0345V29.1379C45 34.1035 41.7122 34.931 39.2464 34.931C38.7936 34.931 38.3755 34.8874 37.995 34.8152C37.812 36.2561 36.3184 36.8707 35.5477 37H16.232C14.317 37 13.2798 34.9201 12.9702 33.7891H12.9443C8.0126 33.7891 6.23173 31.3063 5.95775 30.0649V29.1379C4.30516 29.1379 1 29.3 1 26.5V11.5C1 10.3333 1.99155 8.86207 5.95775 8.86207V8.03448Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95775 19.2069V8.86207M12.9443 4.31034C8.0126 4.31034 6.23173 6.7931 5.95775 8.03448V8.86207M12.9443 4.31034H35.1367C35.9586 4.72414 37.6025 7.04138 37.6025 13V19.2069M12.9443 4.31034C13.2182 3.2069 14.2594 1 16.232 1H35.5477C36.3696 1.13793 38.0135 1.82759 38.0135 3.48276M5.95775 18.8925V29.1379M37.6025 18.8925V25.0994C37.6025 31.058 35.9586 33.3753 35.1367 33.7891H12.9443C8.0126 33.7891 6.23173 31.3063 5.95775 30.0649V29.1379M35.5477 4.31034C35.9586 3.89655 37.2737 3.06897 39.2464 3.06897C41.7122 3.06897 45 3.89655 45 8.86207V20.0345M35.5477 33.6897C35.9586 34.1034 37.2737 34.931 39.2464 34.931C41.7122 34.931 45 34.1034 45 29.1379V17.9655M12.9443 33.6897C13.2182 34.7931 14.2594 37 16.232 37H35.5477C36.3696 36.8621 38.0135 36.1724 38.0135 34.5172M5.95775 29.1379C4.30516 29.1379 1 29.3 1 26.5C1 23.7 1 13.6667 1 11.5C1 10.3333 1.99155 8.86207 5.95775 8.86207",
    stroke: "#435869"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3117_31196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9258 31.5972L21.456 32.186C21.8716 31.7463 22.4233 31.5007 22.9972 31.5C23.571 31.4993 24.1232 31.7435 24.5397 32.1822L25.0695 31.5935C24.5126 30.9983 23.7696 30.6662 22.9969 30.667C22.2242 30.6678 21.4818 31.0009 20.9258 31.5972Z",
    fill: "#435869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3359 29.8307L19.8662 30.4194C20.7032 29.5103 21.827 29.0009 22.9974 29.0001C24.1679 28.9993 25.2922 29.5072 26.1302 30.4152L26.6601 29.8265C25.6816 28.762 24.3666 28.1662 22.9972 28.167C21.6279 28.1678 20.3134 28.7651 19.3359 29.8307Z",
    fill: "#435869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 28.0592C26.8508 26.5263 24.9649 25.667 23 25.667C21.0351 25.667 19.1492 26.5263 17.75 28.0592V28.0688L18.2765 28.6538C19.5344 27.2748 21.2301 26.5014 22.9972 26.5006C24.7642 26.4998 26.4605 27.2718 27.7194 28.6496L28.25 28.06V28.0592Z",
    fill: "#435869"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3117_31196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9258 6.40277L21.456 5.81402C21.8716 6.25373 22.4233 6.49929 22.9972 6.49999C23.571 6.50068 24.1232 6.25646 24.5397 5.81777L25.0695 6.40652C24.5126 7.00169 23.7696 7.33378 22.9969 7.33301C22.2242 7.33223 21.4818 6.99906 20.9258 6.40277Z",
    fill: "#435869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3359 8.16934L19.8662 7.58059C20.7032 8.48972 21.827 8.9991 22.9974 8.99988C24.1679 9.00065 25.2922 8.49277 26.1302 7.58476L26.6601 8.17351C25.6816 9.23798 24.3666 9.83379 22.9972 9.83301C21.6279 9.83223 20.3134 9.23493 19.3359 8.16934Z",
    fill: "#435869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 9.94081C26.8508 11.4737 24.9649 12.333 23 12.333C21.0351 12.333 19.1492 11.4737 17.75 9.94081V9.93122L18.2765 9.34622C19.5344 10.7252 21.2301 11.4986 22.9972 11.4994C24.7642 11.5002 26.4605 10.7282 27.7194 9.35039L28.25 9.93997V9.94081Z",
    fill: "#435869"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3117_31196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white",
    transform: "translate(17 25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3117_31196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    fill: "white",
    transform: "matrix(1 0 0 -1 17 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSeatMassage);
export default __webpack_public_path__ + "static/media/ic-seat-massage.4bfb482cff4d1f13918cdd42cc6079b8.svg";
export { ForwardRef as ReactComponent };